import { useEffect } from "react";
import Map from "ol/Map";

/**
 * isLocked가 true인 동안 DragPan과 DoubleClickZoom 인터랙션을 비활성화합니다.
 * 언마운트 또는 isLocked=false 시 자동으로 복원됩니다.
 */
export function useMapInteractionLock(map: Map, isLocked: boolean) {
  useEffect(() => {
    const setInteractionsActive = (active: boolean) => {
      map.getInteractions().forEach((interaction: any) => {
        const name = interaction?.constructor?.name;
        if (name === "DragPan" || name === "DoubleClickZoom") {
          interaction.setActive(active);
        }
      });
    };

    setInteractionsActive(!isLocked);
    return () => setInteractionsActive(true);
  }, [map, isLocked]);
}
